import styled, { css } from 'styled-components';
import { ThemeColours } from '../../styles/ThemeColours';
import { FontSize, FONT_STACK, LineHeight } from '../../styles/constants';
import { onMobile } from '../../styles/onMobile';
import { ButtonVariants } from '../Button/DeprecatedButtonVariants';
import { IconButton } from '../Button/IconButton';
import { Link } from '../Link';
import { Variant } from './AlertVariants';

const getBackground = (variant: Variant) => css`
  background: ${variant.secondary};
`;

export const AlertContainer = styled.div<Variant>`
  ${getBackground};
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  padding: 16px;

  ${onMobile} {
    padding: 10px;
  }
`;

export const AlertMessage = styled.div`
  ${FONT_STACK}
  color: ${ThemeColours.warning700};
  font-size: ${FontSize.REGULAR};
  line-height: ${LineHeight.REGULAR};
  margin-left: 26px;

  ${onMobile} {
    font-size: ${FontSize.SMALL};
    line-height: ${LineHeight.SMALL};
    margin: 0;
    margin-left: 12px;
  }
`;

export const AlertContent = styled.div`
  align-items: center;
  display: inherit;
  flex-grow: 2;
`;

export const IconArea = styled.div`
  height: 16px;
  width: 16px;
`;

export const CloseIcon = styled(IconButton).attrs({ variant: ButtonVariants.transparent })`
  margin: 0px;
  padding: 0px;
  height: 16px;
  width: 16px;
`;

export const AlertHeader = styled.div`
  ${FONT_STACK}
  color: ${ThemeColours.warning700};
  font-size: ${FontSize.LARGE};
  line-height: ${LineHeight.LARGE};
`;

const bodyFont = css`
  ${FONT_STACK}
  color: ${ThemeColours.warning700};
  font-size: ${FontSize.SMALL};
  line-height: ${LineHeight.SMALL};
`;

export const AlertBody = styled.div`
  ${bodyFont}
`;

export const AlertLink = styled(Link)`
  ${bodyFont}
`;

export const AlertIconContainer = styled.div`
  height: 40px;
  margin: 0px;
  padding: 0px;

  ${onMobile} {
    height: 30px;
    width: 30px;
  }
`;
